/*
 * Click tracking for the buttons that actually drive (or interrupt) the
 * purchase flow: checkout, discount code apply/remove, "view full cart"
 * (mini-cart drawer only, `.hdt-mini-cart__btn-viewcart` — the full /cart
 * page has no equivalent, you're already there), "continue shopping"
 * (mini-cart drawer only too, `[data-cart-return-to-collection]` — confirmed
 * live 2026-09-24, absent from `main-cart.liquid`), the PDP breadcrumb's
 * back-to-collection/prev/next-product links, and the full collection/search
 * filter-and-sort surface: checkbox-and-radio filters, the price-range
 * number inputs, removing one active-filter chip, "clear all", and picking
 * a sort option (which filters and sort orders shoppers actually use is a
 * real merchandising signal).
 *
 * Price-range: only the two `type="number"` inputs are tracked
 * (name="filter.v.price.gte"/"lte"). The `type="range"` sliders next to
 * them have no `name` attribute and fire continuous `input` events while
 * dragged, so they're left alone on purpose — the number inputs only fire
 * `change` on blur/Enter, which is already naturally debounced.
 *
 * Reuses the already-live select_content event (same GTM tag/trigger as
 * the menu clicks) — no new GTM work needed, just a different
 * content_type per button so they're distinguishable in reports.
 */
(function () {
  'use strict';

  function push(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function selectContent(contentType, itemId, itemName) {
    push('select_content', {
      content_type: contentType,
      item_id: itemId || '',
      item_name: itemName || ''
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var checkoutBtn = target.closest('button[name="checkout"]');
    if (checkoutBtn) {
      selectContent('checkout_button');
      return;
    }

    var discountApply = target.closest('[data-cart-discount-apply]');
    if (discountApply) {
      var scope = discountApply.closest('hdt-cart-discount');
      var input = scope ? scope.querySelector('[data-cart-discount-input]') : null;
      selectContent('discount_apply', input ? input.value : '');
      return;
    }

    var discountRemove = target.closest('.hdt-discount-remove');
    if (discountRemove) {
      selectContent('discount_remove', discountRemove.getAttribute('data-discount-code') || '');
      return;
    }

    var viewCart = target.closest('.hdt-mini-cart__btn-viewcart');
    if (viewCart) {
      selectContent('view_cart_page');
      return;
    }

    var continueShopping = target.closest('[data-cart-return-to-collection]');
    if (continueShopping) {
      selectContent('continue_shopping');
      return;
    }

    var pdpBack = target.closest('.hdt-breadcrumb__back');
    if (pdpBack) {
      selectContent('pdp_back_to_collection');
      return;
    }

    var pdpPrev = target.closest('.hdt-breadcrumb__prev');
    if (pdpPrev) {
      selectContent('pdp_prev_product');
      return;
    }

    var pdpNext = target.closest('.hdt-breadcrumb__next');
    if (pdpNext) {
      selectContent('pdp_next_product');
      return;
    }

    var filterRemove = target.closest('.hdt-active-filters__remove');
    if (filterRemove) {
      selectContent('collection_filter_remove', '', filterRemove.textContent.trim());
      return;
    }

    var filterClearAll = target.closest('.hdt-active-filters__clear-all');
    if (filterClearAll) {
      selectContent('collection_filter_clear_all');
      return;
    }

    var sortOption = target.closest('hdt-richlist button[role="option"]');
    if (sortOption) {
      selectContent('collection_sort', sortOption.getAttribute('value') || '', sortOption.textContent.trim());
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.name || input.name.indexOf('filter.') !== 0) return;
    if (input.type !== 'checkbox' && input.type !== 'radio' && input.type !== 'number') return;
    var item = input.closest('li, .hdt-filter-group__list-item');
    var label = item && item.querySelector('label');
    var valueText = label ? label.textContent.trim() : (input.getAttribute('aria-label') || input.value);
    selectContent('collection_filter', input.name + '=' + input.value, valueText);
  }, true);
}());
